// ** MUI Theme Provider
import { deepmerge } from '@mui/utils'

// ** Theme Override Imports
import palette from './palette'
import spacing from './spacing'
import shadows from './shadows'
import typography from './typography'
import breakpoints from './breakpoints'
import Overrides from './overrides'

const ThemeOptions = (settings, overrideMode) => {
  // ** Create New object before removing user component overrides and typography objects from userThemeOptions
  const userThemeConfig = Object.assign({}, () => {})

  const mergedThemeConfig = deepmerge(
    {
      breakpoints: breakpoints(),
      // direction,
      components: Overrides(settings),
      palette: palette('light', 'default'),
      ...spacing,
      shape: {
        borderRadius: 6
      },
      mixins: {
        toolbar: {
          minHeight: 64
        }
      },
      shadows: shadows(),
      typography
    },
    userThemeConfig
  )

  return deepmerge(mergedThemeConfig, {
    palette: {
      primary: {
        contrastText: '#FFF',
        dark: '#2c5dfe',
        light: '#2c5dfe',
        main: '#2c5dfe'
      }
    }
  })
}

export default ThemeOptions
